import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Accordion, Card } from 'react-bootstrap';
import useDate from '../../../utils/useDate';
import UserDefinedLabels from '../../../utils/UserDefinedLabels';
import { maskedOther, maskedSSN } from '../../../../common/masking';
import { formatDependentName } from '../../../utils/common';
import { Avatar } from '@material-ui/core';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../img/findcare/FindCareSVG';
import CustomClientError from '../../../errorhandling/CustomClientError';
import Skeleton from './skeleton/DependentInfoSkeleton';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import EditIcon from 'src/Admin/img/myProfile/EditIcon';
import './styles/personal-info.scss';
import MasterPermissions from '../../../api/MasterPermissions';

const Dependents = ({
  fetchDependentsData,
  dependentsData,
  onClickEdit,
  showEditButton = true,
}) => {
  const [activeId, setActiveId] = useState(null);
  const { t } = useTranslation();
  const noValue = 'Not Specified';
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { CertificateNumberLabel, AlternateID1Label, AlternateID2Label } =
    UserDefinedLabels();
  const { formatDate } = useDate();

  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }

  const toggleActive = async (id, dependentsInfoLoaded, dependentsAPIError) => {
    if (!dependentsInfoLoaded || (dependentsInfoLoaded && dependentsAPIError)) {
      fetchDependentsData(id);
    }

    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };
  return (
    <div className="my-profile-member-container">
      <div>
        <h2 className="row-title" tabIndex={0}>
          Dependents
        </h2>
      </div>

      {dependentsData?.length ? (
        <Accordion>
          {
            <div className="personal-info-section">
              {dependentsData &&
                dependentsData.map((item, index) => (
                  <div key={index} className="mb-1">
                    <Accordion.Toggle
                      as={Card.Header}
                      onClick={() =>
                        toggleActive(
                          item.DepSequenceNumber,
                          item.dependentsInfoLoaded,
                          item.dependentsAPIError,
                        )
                      }
                      className="bg-white panel-toggle border-0 py-3"
                      eventKey={item.DepSequenceNumber}
                    >
                      <div className="d-flex panel-card-header align-items-center">
                        <div className="pr-3">
                          <span className="accordion-arrow">
                            {activeId === item.DepSequenceNumber ? (
                              <AccordionUpArrow className="acc-arrow" />
                            ) : (
                              <AccordionDownArrow className="acc-arrow" />
                            )}
                          </span>
                        </div>
                        <div className="top-header-container border-0 w-100 p-0">
                          <div className="avarat-wrapper">
                            <Avatar className="my-profile-avatar">
                              {item.DepFirstName &&
                                item.DepFirstName.charAt(0).toUpperCase()}
                              {item.DepLastName &&
                                item.DepLastName.charAt(0).toUpperCase()}
                            </Avatar>
                          </div>
                          <div className="title-age-container">
                            <div className="my-profile-title">{`${formatDependentName(
                              item,
                            )}`}</div>
                            <div className="my-profile-age">
                              {item.RelationshipToEmployee || ''}
                            </div>
                          </div>
                          <div className="my-profile-status">
                            <div>Status</div>
                            <div className="font-weight-bold">
                              {item.Status || noValue}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={item.DepSequenceNumber}>
                      <Card.Body className="bg-white px-4 py-2">
                        {!item.dependentsInfoLoaded ? (
                          <Skeleton />
                        ) : !item.dependentsAPIError ? (
                          <>
                            <div className="pt-2 member-details-container">
                              <div className="first-column">
                                {Suppress_Setting?.memberId !== 'hide' && (
                                  <div>
                                    <label>{CertificateNumberLabel}</label>
                                    <span className="plain-text ">
                                      {maskedOther(
                                        Suppress_Setting?.memberId
                                          ? Suppress_Setting?.memberId
                                          : false,
                                        item.DependentsInformation
                                          .CertificateNumber,
                                      ) || noValue}
                                    </span>
                                  </div>
                                )}

                                <div>
                                  <label>
                                    {t('member.pages.my_profile.labels.dob')}
                                  </label>
                                  <span className="plain-text ">
                                    {
                                      !item.DependentsInformation.BirthDate
                                        ? noValue
                                        : formatDate(
                                            item.DependentsInformation
                                              .BirthDate,
                                          )
                                      //moment( item.BirthDate ).format( 'DD-MMM-YYYY' )
                                    }
                                  </span>
                                </div>

                                <div>
                                  <label>
                                    {t('member.pages.my_profile.labels.gender')}
                                  </label>
                                  <span className="plain-text ">
                                    {item.DependentsInformation.Gender ||
                                      noValue}
                                  </span>
                                </div>

                                <div>
                                  <label>
                                    {t('member.pages.my_profile.labels.race')}
                                  </label>
                                  <span className="plain-text ">
                                    {item.DependentsInformation.Race || noValue}
                                  </span>
                                </div>

                                {/*<div>
                              <label>{t('member.pages.my_profile.labels.marital_status')}</label>
                              <span className="plain-text ">{item.DependentsInformation.MartialStatus || noValue}</span>
                          </div> */}
                              </div>
                              <div className="second-column">
                                {/*{'Employee' == loggedInMemberType &&
                                  <div>
                                  <label>{t('member.pages.my_profile.labels.no_of_dependents')}</label>
                                  <span className="plain-text ">{item.NumberOfDependents || noValue}</span>
                                  </div>
                              } */}
                                <div>
                                  <label>
                                    {t('member.pages.my_profile.labels.age')}
                                  </label>
                                  <span className="plain-text ">
                                    {item.DependentsInformation.Age || noValue}
                                  </span>
                                </div>

                                {Suppress_Setting?.SSN !== 'hide' &&
                                  item.DependentsInformation
                                    .SocialSecurityNumber && (
                                    <div>
                                      <label>
                                        {t(
                                          'member.pages.my_profile.labels.ssn',
                                        )}
                                      </label>
                                      <span className="plain-text ">
                                        {maskedSSN(
                                          Suppress_Setting?.SSN
                                            ? Suppress_Setting?.SSN
                                            : false,
                                          item.DependentsInformation
                                            .SocialSecurityNumber,
                                        )}
                                      </span>
                                    </div>
                                  )}

                                {Suppress_Setting?.altId1 !== 'hide' && (
                                  <div>
                                    <label>{AlternateID1Label}</label>
                                    <span className="plain-text ">
                                      {maskedOther(
                                        Suppress_Setting?.altId1
                                          ? Suppress_Setting?.altId1
                                          : false,
                                        item.DependentsInformation.AlternateID1,
                                      ) || noValue}
                                    </span>
                                  </div>
                                )}

                                {Suppress_Setting?.altId2 !== 'hide' && (
                                  <div>
                                    <label>{AlternateID2Label}</label>
                                    <span className="plain-text ">
                                      {maskedOther(
                                        Suppress_Setting?.altId2
                                          ? Suppress_Setting?.altId2
                                          : false,
                                        item.DependentsInformation.AlternateID2,
                                      ) || noValue}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="pt-2">
                              <div className="contact-info-section">
                                <div className="top-header-container">
                                  <div className="title">
                                    {t(
                                      'member.pages.my_profile.labels.contact_information',
                                    )}
                                  </div>
                                  {showEditButton &&
                                    (MasterPermissions.CheckPermission(
                                      'Edit Dependent Contact Information',
                                    ) ||
                                      MasterPermissions.CheckPermission(
                                        'Edit Dependent Address Information',
                                      )) && (
                                      <div>
                                        <GenericButton
                                          variant="secondary"
                                          onClick={onClickEdit}
                                        >
                                          <EditIcon
                                            fillColor={
                                              themeValuesObject[
                                                'Secondary-1'
                                              ] || '#1d90ba'
                                            }
                                          />{' '}
                                          Edit
                                        </GenericButton>
                                      </div>
                                    )}
                                </div>
                                <div className="pt-2 contact-container">
                                  <div className="first-column">
                                    <div>
                                      <label>
                                        {t('member.common_labels.email')}
                                      </label>
                                      <span className="plain-text ">
                                        {item.PhoneEmailInfo?.Email1 || noValue}
                                      </span>
                                    </div>
                                    <div>
                                      <label>
                                        {t(
                                          'member.common_labels.alternate_email',
                                        )}
                                      </label>
                                      <span className="plain-text ">
                                        {item.PhoneEmailInfo?.Email2 || noValue}
                                      </span>
                                    </div>
                                    <div>
                                      <label>
                                        {t(
                                          'member.pages.my_profile.labels.home_phone',
                                        )}
                                      </label>
                                      <span className="plain-text ">
                                        {item.PhoneEmailInfo?.HomePhone ||
                                          noValue}
                                      </span>
                                    </div>
                                    <div>
                                      <label>
                                        {t(
                                          'member.pages.my_profile.labels.work_phone',
                                        )}
                                      </label>
                                      <span className="plain-text ">
                                        {item.PhoneEmailInfo?.WorkPhone ||
                                          noValue}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="second-column">
                                    <div>
                                      <label>
                                        {t(
                                          'member.common_labels.residential_address',
                                        )}
                                      </label>
                                      <span className="plain-text ">
                                        {item.DependentResidentailAddress.trim() ||
                                          noValue}
                                        <br />
                                        {item.DependentResidentailAddressZip.trim() ||
                                          ''}
                                      </span>
                                    </div>
                                    <div>
                                      <label>
                                        {t(
                                          'member.common_labels.mailing_address',
                                        )}
                                      </label>
                                      <span className="plain-text ">
                                        {item.DependentMailingAddress.trim() ||
                                          noValue}
                                        <br />
                                        {item.DependentMailingAddressZip.trim() ||
                                          ''}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <CustomClientError
                            ErrorHeading="Something went wrong with request!"
                            ErrorMessage="Please try again."
                          />
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                ))}
            </div>
          }
        </Accordion>
      ) : (
        <CustomClientError
          ErrorHeading="This Member does not have any Dependent(s)."
          ErrorMessage="To add a Dependent, contact your Administrator."
        />
      )}
    </div>
  );
};

export default Dependents;
